"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsPage = exports.AccountsPageConfig = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var icons_1 = require("../components/icon/icons");
var i18n_1 = require("../i18n");
var accounts_1 = require("../modules/accounts/accounts");
var accounts_ctrl_1 = require("../modules/accounts/accounts.ctrl");
var services_1 = require("../services");
var page_1 = require("./page");
exports.AccountsPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.accountList,
    path: '/user/accounts',
    auth: {
        required: true,
        userLevel: [core_api_1.IkeUserRole.ROOT]
    },
    nav: {
        name: i18n_1.T.LIST_USER_ACCOUNTS,
        icon: icons_1.MaterialIcon.PERSON
    }
};
var AccountsPage = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsPage, _super);
    function AccountsPage() {
        var _this = _super.call(this, exports.AccountsPageConfig) || this;
        _this.name = 'AcceptInvite';
        var ctrl = new accounts_ctrl_1.AccountsCtrl();
        _this.component = new accounts_1.AccountsComponent(ctrl);
        return _this;
    }
    Object.defineProperty(AccountsPage.prototype, "nodes", {
        get: function () {
            if (!services_1.Services.User.hasUser) {
                return null;
            }
            return this.component.view();
        },
        enumerable: false,
        configurable: true
    });
    return AccountsPage;
}(page_1.IkePage));
exports.AccountsPage = AccountsPage;
//# sourceMappingURL=accounts.page.js.map